import IconSvg, { IconSvgProps } from 'core/_legacy/icons/IconSvg'

const TutoringIcon = ({
  width = 25,
  height = 25,
  color = '#96A2C2'
}: Omit<IconSvgProps, 'children'>) => (
  <IconSvg
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width="50"
    height="50"
    viewBox="0 0 50 50"
    style={{
      fill: color,
      width: width,
      height: height
    }}
    className="icon icons8-reading-filled"
  >
    <g id="surface1">
      <path d="M 25 0 C 19.484375 0 15 4.484375 15 10 C 15 11.070313 15.1875 12.085938 15.5 13.0625 C 19.742188 13.832031 22.824219 14.878906 24.71875 15.625 L 25 15.71875 L 25.28125 15.625 C 27.175781 14.878906 30.265625 13.863281 34.5 13.09375 C 34.816406 12.109375 35 11.058594 35 10 C 35 4.484375 30.515625 0 25 0 Z M 3 14 C 2.449219 14 2 14.449219 2 15 L 2 21 L 3 21 C 5.804688 21 8 23.195313 8 26 L 8 28 C 8 30.804688 5.804688 33 3 33 L 2 33 L 2 43 C 2 43.554688 2.449219 44 3 44 C 14.84375 44 22.261719 48.386719 24 49.53125 L 24 17.46875 C 21.085938 16.320313 13.84375 14 3 14 Z M 47 14 C 36.15625 14 28.914063 16.320313 26 17.46875 L 26 49.53125 C 27.738281 48.386719 35.160156 44 47 44 C 47.554688 44 48 43.554688 48 43 L 48 33 L 47 33 C 44.195313 33 42 30.804688 42 28 L 42 26 C 42 23.195313 44.195313 21 47 21 L 48 21 L 48 15 C 48 14.449219 47.554688 14 47 14 Z M 2 23 C 0.898438 23 0 23.898438 0 25 L 0 29 C 0 30.101563 0.898438 31 2 31 L 3 31 C 4.699219 31 6 29.699219 6 28 L 6 26 C 6 24.300781 4.699219 23 3 23 Z M 47 23 C 46.789063 23 46.574219 23.023438 46.375 23.0625 C 44.988281 23.335938 44 24.511719 44 26 L 44 28 C 44 29.699219 45.300781 31 47 31 L 48 31 C 49.101563 31 50 30.101563 50 29 L 50 25 C 50 23.898438 49.101563 23 48 23 Z " />
    </g>
  </IconSvg>
)

export default TutoringIcon
